import React from 'react';

export type RecentSearchContextType = {
  currentKey: string;
};

export const RecentSearchContext = React.createContext<RecentSearchContextType | undefined>(
  undefined,
);
